import { Link } from '@inertiajs/react';
import type { MenuType } from '@/_types/Shared/SiteDatas';

export default function CustomLink ({ item }: { item: MenuType }) {
	return (
		<>
			{item.type === 'custom' ? (
				<a href={item.url} >
					{item.title}
				</a>
			) : (
				<Link href={item.url}>
					{item.title}
				</Link>
			)}
		</>
	);
}